<!-- Start Blog Area -->
<app-navbar-style-two></app-navbar-style-two>
<section class="blog-area pt-50 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>{{details.postTitle}}</h2>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-6">
                <div class="single-blog-post">
                    <div class="post-image">
                        <img [src]="details.imageUrl" alt="image" class="responsive-img">
                    </div>
                    <div class="post-content">
                        <p style="text-align: justify;">{{details.postDesciption}}</p>

                    </div>

                    <br>
                </div>
                <div class="single-blog-post" *ngFor="let obj of otherDetails">
                    <h4 style="padding-top: 20px;">{{ obj.title }}</h4>

                    <div class="post-image" >
                        <img [src]="obj.imageUrl" alt="image" class="responsive-img" *ngIf="obj.imageUrl != ''">

                        <div *ngIf="obj?.videoUrl && obj.videoUrl.includes('youtube.com') && playingVideoId !== obj.id" class="video-thumbnail thumbnail-image"
                                (click)="playVideo(obj.id)">
                                <img [src]="getYoutubeThumbnail(obj.videoUrl)" alt="Video thumbnail" />
                                <div class="play-button"></div>
                            </div>
                        <ng-container *ngIf="obj?.videoUrl && obj.videoUrl.includes('youtube.com') && playClicked && playingVideoId === obj.id" >
                            <div class="video-wrapper" *ngIf="obj?.videoUrl && obj.videoUrl.includes('youtube.com')" >
                        
                            <!-- Iframe shown when playing -->
                            <iframe *ngIf="playingVideoId === obj.id" [src]="getCachedSafeUrl(obj.id)" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen>
                            </iframe>
                        </div>
                        </ng-container>
                        

                        <p>{{obj.videoUrl}}</p>
                        <div class="post-content">
                            <p style="text-align: justify;">{{obj.otherDescription}}</p>

                        </div>
                    </div>
                </div>



                <!--div class="single-blog-post" *ngFor="let obj of otherDetails">
                    <h4>{{obj.title}}</h4>
                    <div class="post-image" style="padding-bottom: 10px;">
                        <img [src]="obj.imageUrl" alt="image" class="responsive-img" *ngIf="obj.imageUrl != ''">
                        <div class="video-wrapper" *ngIf="obj?.videoUrl && obj.videoUrl.includes('youtube.com')">
                    
                            <div *ngIf="!isPlaying" class="video-thumbnail" (click)="playVideo()">
                                <img [src]="getYoutubeThumbnail(obj.videoUrl)" alt="Video thumbnail"
                                    class="youtube-thumb">
                                <div class="play-button"></div>
                            </div>

                   
                            <iframe *ngIf="isPlaying" [src]="getSafeYoutubeUrl(obj.videoUrl)" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen>
                            </iframe>
                        </div>


                        <div class="video-wrapper" *ngIf="obj.videoUrl && obj.videoUrl.includes('youtube.com')">
                            <iframe [src]="getSafeYoutubeUrl(obj.videoUrl)" frameborder="0"
                                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen>
                            </iframe>
                        </div>

                        <p>{{obj.videoUrl}}</p>
                    </div>

                    <div class="post-image" style="padding-bottom: 10px;">
                        <img [src]="obj.imageUrl" alt="image" class="responsive-img" *ngIf="obj.imageUrl !=''">
                        <iframe *ngIf="obj.videoUrl && obj.videoUrl.includes('youtube.com')"
                            [src]="getSafeYoutubeUrl(obj.videoUrl)" class="responsive-video" frameborder="0"
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen>
                        </iframe>
                        <p>{{obj.videoUrl}}</p>
                    </div>
                    <div class="post-content">
                        <p style="text-align: justify;">{{obj.otherDescription}}</p>

                    </div>

                    <br>
                </div-->
            </div>
        </div>
    </div>
</section>
<!-- End Blog Area -->